module.exports = __webpack_public_path__ + "static/img/timg.60fb6104.jpg";